<template>
    <div id="MessageCenter__Editor" :class="`${isImportant ? 'highlight-important' : ''}`">
        <SummerEditor
            :isImportant="isImportant"
            :options="editorOptions"
            ref="summerEditorRef"
            :refs-Name="refsName"
            :initial-value="sanitizeMarkup(markdownToHtml(initialMessage))"
            :result="result"
            @update:result="updateResult"
            :selectedProfile="selectedProfile"
            @update:selectedProfile="updateSelectedProfile"
            :allSelectedProfiles="allSelectedProfiles"
            :selectedConversation="activeConversation"
            :editMsg="editMsg"
            @update:msgFiles="updateMsgFiles"
            v-on:sendMessage="sendMessage"
            :shouldDisableSend="shouldDisableSend"
            :isFamilyPortal="isFamilyPortal"
        />
    </div>
</template>

<style src="./MessageInputHandler.scss"></style>
<script lang="ts" src="./MessageInputHandler.ts"></script>
